module.exports = __webpack_public_path__ + "static/media/star-struck.15505447.png";